import { createRoot } from 'react-dom/client';
import GunGuard from './gunguard';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<GunGuard />);
